"use strict";
exports.__esModule = true;
exports.CONNECT_CARD = void 0;
exports.CONNECT_CARD = {
    HEADER: "Let's add your card",
    BODY_LINE_1: 'Add the card you’d like to use for your payments and membership fee. Don’t worry, we won’t charge you until your rent is due.',
    BODY_LINE_2: 'Flex charges a {{debitProcessingFee}}% bill payment fee on the total rent amount.',
    BODY_LINE_3: 'An additional {{creditProcessingFee}}% processing fee will be applied when paying with a credit card.',
    BODY_LINE_4: 'No additional processing fee will be applied when paying with a debit card.',
    CTA: 'Continue'
};
